import { isProductionHost } from 'lib/env';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debugLog = (...args: any) => {
    if (!isProductionHost()) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        console.log(...args);
    }
};
